/* unplugin-vue-components disabled */import script from "./TaxSales.vue?vue&type=script&setup=true&lang=js"
export * from "./TaxSales.vue?vue&type=script&setup=true&lang=js"

import "./TaxSales.vue?vue&type=style&index=0&id=51dbcd5e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51dbcd5e"]])

export default __exports__